/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-06.
 * Reducer for the container.
 */
import { updateState } from './common/helpers';
import { GLOBAL_NOTIFY } from './global.types';
import { SnackBar } from './components/widgets';

const INITIAL_STATE = {
    snackbarConfig: {
        open: false,
        message: '',
        type: SnackBar.INFO
    }
};

export default (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        case GLOBAL_NOTIFY:
            return updateState(payload, state);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./global.reducer.js